const Hunter = () =>
  import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/hunter");

const Contracts = () =>
  import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/contracts");
const HunterDashboard = () =>
  import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/dashboard");
const HunterActivation = () =>
  import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/activation");
const OrderDetail = () =>
    import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/order-detail");
const HunterHelp = () =>
    import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/help");
const Kpi = () =>
    import(/* webpackChunkName: "hunter" */ "@/app/admin/kpi/index");
const Enterprise = () =>
    import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/enterprise");
const Enterprisedetails = () =>
    import(/* webpackChunkName: "hunter" */ "@/app/admin/hunter/enterprisedetails");

export default [
  {
    path: "kpi",
    name: "kpi",
    component: Kpi,
    meta: {
      title: "猎头管理",
      key: "kpi",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter-enterprise",
    name: "hunter-enterprise",
    component: Enterprise,
    meta: {
      title: "猎企管理",
      key: "hunter-enterprise",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter-enterprise-details",
    name: "hunter-enterprise-details",
    component: Enterprisedetails,
    meta: {
      title: "猎企管理-详情",
      key: "hunter-enterprise-details",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter",
    name: "hunter",
    component: Hunter,
    meta: {
      title: "猎头管理",
      key: "hunter",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter-help",
    name: "hunter-help",
    component: HunterHelp,
    meta: {
      title: "猎头求助订单",
      key: "hunter-help",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter-dashboard",
    name: "hunter-dashboard",
    component: HunterDashboard,
    meta: {
      title: "开发数据",
      key: "hunter-dashboard",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter-activation",
    name: "hunter-activation",
    component: HunterActivation,
    meta: {
      title: "激活数据",
      key: "hunter-activation",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter-dashboard/detail/:id",
    name: "hunter-orderDetail",
    component: OrderDetail,
    meta: {
      title: "订单详情",
      key: "hunter-dashboard",
      permission: "hunter_manager.hunter_list"
    }
  },
  {
    path: "hunter-contracts",
    name: "hunter-contracts",
    component: Contracts,
    meta: { title: "猎头管理", key: "hunter", permission: "hunter_manager" }
  }
];
